module.exports = __webpack_public_path__ + "img/8.cbd2a40f.gif";